// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"125":"61d629ba","938":"ad3c56b6"}[chunkId] + ".css";
};